import type { TPortugueseTranslations } from '@crehana/ts-types';

import { COMPONENT_KEY } from '../constants';
import type { TKeys } from './types';

type TTranslations = TPortugueseTranslations<TKeys, typeof COMPONENT_KEY>;

const pt: TTranslations = {
  [COMPONENT_KEY]: {
    TITLE_PAGE_ZERO: 'Um erro ocorreu',
    DESCRIPTION_PAGE_ZERO: 'Atualize ou tente novamente mais tarde.',
    BUTTON_PAGE_ZERO: 'Tentar novamente',
    TITLE_PAGE_NOT_FOUND: 'página não encontrada',
    DESCRIPTION_PAGE_NOT_FOUND: 'A página não existe ou não foi encontrada.',
    BACK: 'Retornar',
    TITLE_PAGE_ZERO_NOT_PROCES: 'Você ainda não faz parte de nenhum processo!',
    MY_PID: 'Meu PID',
    MY_TEAM: 'minha equipe',
    PID_TITLE: 'Plano de Desenvolvimento Individual',
    PID_DESCRIPTION: 'Impulsione seu desenvolvimento profissional',
    performance: 'Desempenho',
    PID: 'P.I.D.',
  },
};

export default pt;
